/**
 * Shared dark glass panel shell — used on the login brand panel and app navigation sidebar.
 */
export default function LoginSidebarShell({ className = "", children }) {
  return (
    <div
      className={`relative flex flex-col overflow-hidden rounded-[2rem] border border-[#ffffff1f] bg-[#0a0a0d]/95 shadow-[0_20px_48px_-18px_rgba(0,0,0,0.7)] ${className}`}
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -top-20 -left-20 h-64 w-64 rounded-full bg-[#8f152f]/28 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute bottom-10 -right-12 h-48 w-48 rounded-full bg-[#b81f44]/24 blur-3xl"
      />
      <div className="relative z-10 flex flex-1 flex-col min-h-0">{children}</div>
    </div>
  );
}
